// features/council/CouncilPage.tsx — /council and /council/<section>.
//
// Signed in: the full console. Signed OUT: the public record, NOT a redirect
// to sign-in. The front page promises "see the Council ... no account needed"
// in two places (landing/sections/CouncilSection.tsx, VerdictsSection.tsx),
// and until 1.24.80 both promises put the reader on a login form — the one
// move a platform selling "moderation you can see" cannot make. Reading the
// record needs no account; voting still needs a member, and always did.
//
// A signed-out visitor asking for a specific console section is sent to the
// record rather than the form: the sections are moderator tools, and there is
// no public version of a Voting Board.
import { Navigate, useParams } from 'react-router-dom';
import { useSession } from '@/hooks';
import { isSectionId } from './meta';
import { CouncilLayout } from './CouncilLayout';
import { PublicRecordPage } from './PublicRecordPage';

export function CouncilPage() {
  const { isAuthenticated } = useSession();
  const { section } = useParams();

  if (!isAuthenticated) {
    return section ? <Navigate to="/council" replace /> : <PublicRecordPage />;
  }
  if (section && !isSectionId(section)) {
    return <Navigate to="/council" replace />;
  }
  return <CouncilLayout activeId={section ?? 'overview'} />;
}
